import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'DeviceCarousel',
  props: {
    itemsNumber: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  components: {},
  emits: [],
})
export default class DeviceCarousel extends Vue {
  itemsNumber!: number;

  SLIDE_WIDTH = 0;
  SLIDE_SHIFT_PX = 0;
  SLIDE_WRAPPER_WIDTH = 0;

  currentStep = 0;
  currentNegativeLXMargin = 0;

  // display properties
  showHandlers = false;

  mounted() {
    this.attachListeners();
    this.$nextTick(() => this.inferSlideType());
  }

  unmounted() {
    this.detachListeners();
  }

  get totalSteps(): number {
    return this.itemsNumber;
  }

  get isLastStep(): boolean {
    return this.currentStep === this.totalSteps - 1;
  }

  get isFirstStep(): boolean {
    return this.currentStep === 0;
  }

  private getFirstActualSlide(): HTMLDivElement {
    const slidesWrp = this.$refs.slidesWrp as HTMLDivElement;
    return [...slidesWrp.children].find(child => child.classList.contains('room-object')) as HTMLDivElement;
  }

  prevSlide() {
    this.setSizes();
    if (this.isFirstStep) return;
    this.currentNegativeLXMargin += this.SLIDE_SHIFT_PX;
    if (this.currentNegativeLXMargin > 0) {
      this.currentNegativeLXMargin = 0;
    }
    this.getFirstActualSlide().style.marginLeft = `${
      this.currentNegativeLXMargin}px`;
    this.currentStep--;
  }

  nextSlide() {
    this.setSizes();
    if (this.isLastStep) return;
    this.currentNegativeLXMargin -= this.SLIDE_SHIFT_PX;
    this.getFirstActualSlide().style.marginLeft = `${this.currentNegativeLXMargin}px`;
    this.currentStep++;

    if (!this.isFirstStep) {
      this.getFirstActualSlide().style.marginLeft = `${
        this.currentNegativeLXMargin}px`;
    }
  }

  protected inferSlideType() {
    this.setSizes();
    this.showHandlersIfNeeded();
  }

  private onWindowResize() {
    this.setSizes();
  }

  private attachListeners() {
    window.addEventListener('resize', this.onWindowResize);
  }

  private detachListeners() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  private setSizes(): void {
    this.SLIDE_WIDTH = this.getFirstActualSlide().offsetWidth;
    this.SLIDE_SHIFT_PX = this.SLIDE_WIDTH + 1;
    this.SLIDE_WRAPPER_WIDTH = (this.$refs
      .slidesWrp as HTMLDivElement).offsetWidth;
  }

  private showHandlersIfNeeded() {
    this.showHandlers =
      (this.itemsNumber) * this.SLIDE_SHIFT_PX > this.SLIDE_WRAPPER_WIDTH;
  }
}
